import { useLocation } from "react-router-dom";
import { CampaignQueryParam, ParamTypes } from "../const";
import CampaignNgoPage from "./CampaignNgoPage";
import CampaignOrgPage from "./CampaignOrgPage";

const CampaignNgoOrgPage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get(CampaignQueryParam.TYPE);

  // if (type === ParamTypes.ORGANIZATION) {
  return <CampaignNgoPage />;
  // }

  // return <CampaignOrgPage />;
};

export default CampaignNgoOrgPage;
